function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icons / 16 / speech bubble"
}, /*#__PURE__*/React.createElement("g", {
  id: "Union"
}, /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 13C12.4183 13 16 10.0899 16 6.5C16 2.91015 12.4183 0 8 0C3.58172 0 0 2.91015 0 6.5C0 8.55269 1.17108 10.3831 3 11.5744L3 16L7 13L7.07209 12.9567C7.37652 12.9853 7.68615 13 8 13Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3 11.5744H5L5 10.4902L4.09154 9.89849L3 11.5744ZM3 16H1L1 20L4.2 17.6L3 16ZM7 13L5.97101 11.285L5.88254 11.3381L5.8 11.4L7 13ZM7.07209 12.9567L7.25896 10.9655L6.60572 10.9042L6.0431 11.2418L7.07209 12.9567ZM14 6.5C14 8.61724 11.7218 11 8 11V15C13.1148 15 18 11.5625 18 6.5H14ZM8 2C11.7218 2 14 4.38276 14 6.5H18C18 1.43754 13.1148 -2 8 -2V2ZM2 6.5C2 4.38276 4.27822 2 8 2V-2C2.88523 -2 -2 1.43754 -2 6.5H2ZM4.09154 9.89849C2.70562 8.99581 2 7.74098 2 6.5H-2C-2 9.3644 -0.363467 11.7705 1.90846 13.2502L4.09154 9.89849ZM5 16V11.5744H1L1 16H5ZM5.8 11.4L1.8 14.4L4.2 17.6L8.2 14.6L5.8 11.4ZM6.0431 11.2418L5.97101 11.285L8.02899 14.715L8.10108 14.6717L6.0431 11.2418ZM8 11C7.74853 11 7.50126 10.9882 7.25896 10.9655L6.88522 14.948C7.25177 14.9824 7.62376 15 8 15V11Z",
  fill: "#313434",
  mask: "url(#path-1-inside-1)"
})));

var SvgSpeechBubble = function SvgSpeechBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeechBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speech-bubble.0bcb45da.svg";
export { ForwardRef as ReactComponent };